module.exports = __webpack_public_path__ + "static/img/custom-anodized-aluminum-signs.b8bd391.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/specialty-items/custom-anodized-aluminum-signs.jpg
// module id = 684
// module chunks = 0